export default [
  {
    itemType: 'tabbed',
    tabPanelOptions: {
      deferRendering: false
    },
    tabs: [{
      title: 'Dados Principais',
      items: [
        {
          itemType: 'group',
          colCount: 8,
          items: [
            {
              colSpan: 2,
              dataField: 'cnpj',
              label: { text: 'CNPJ' },
              editorOptions: {
                mask: '00.000.000/0000-00'
              }
            },
            {
              colSpan: 3,
              dataField: 'nome_empresa',
              label: { text: 'Nome' },
              validationRules: [{
                type: 'required',
                message: 'Nome é obrigatório'
              }]
            },
            {
              colSpan: 3,
              dataField: 'nome_fantasia',
              label: { text: 'Fantasia' }
            }
          ]
        },
        {
          itemType: 'group',
          colCount: 4,
          items: [
            {
              dataField: 'responsavel',
              label: { text: 'Responsável' }
            },
            {
              dataField: 'email',
              label: { text: 'E-mail' }
            },
            {
              dataField: 'telefone',
              label: { text: 'Telefone' },
              editorOptions: {
                mask: '(00) 00000000#'
              }
            },
            {
              dataField: 'celular',
              label: { text: 'Celular' },
              editorOptions: {
                mask: '(00) 00000000#'
              }
            }
          ]
        }
      ]
    }, {
      title: 'Endereço',
      items: [
        {
          itemType: 'group',
          colCount: 7,
          items: [
            {
              colSpan: 3,
              dataField: 'endereco',
              label: { text: 'Endereço' }
            },
            {
              dataField: 'numero',
              label: { text: 'Número' }
            },
            {
              colSpan: 3,
              dataField: 'complemento',
              label: { text: 'Complemento' }
            }
          ]
        },
        {
          itemType: 'group',
          colCount: 8,
          items: [
            {
              colSpan: 2,
              dataField: 'bairro',
              label: { text: 'Bairro' }
            },
            {
              colSpan: 3,
              template: 'cidade'
            },
            {
              colSpan: 2,
              template: 'estado'
            },
            {
              dataField: 'cep',
              label: { text: 'CEP' },
              editorOptions: {
                mask: '00.000-000'
              }
            }
          ]
        }
      ]
    }]
  }
]
